var map = {
	"./blackDragon.png": 674,
	"./brownDragon.png": 270,
	"./chineseDragon.png": 213,
	"./dancingDragon.png": 135,
	"./goldenDragon-removebg.png": 632,
	"./greenDragon.png": 604,
	"./logo.png": 338,
	"./redDragon.png": 522,
	"./silverDragon.png": 80,
	"./skullDragon.png": 201,
	"./spikedDragon.png": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;